package music.jammers.client.shared.component.track.presentation.ui

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.sizeIn
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.event_detail_screen_track_artist_and_track
import limasoul.client.shared.generated.resources.ic_not_ready
import limasoul.client.shared.generated.resources.ic_ready
import music.jammers.shared.event.track.domain.model.EventTrack
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

private const val MAX_TRACK_NAME_WIDTH = 260

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun FreezeTrackCard(
    modifier: Modifier = Modifier,
    eventTrack: EventTrack,
) {
    Card(
        modifier = modifier
            .fillMaxWidth()
            .padding(
                top = 8.dp,
                bottom = 8.dp,
                start = 0.dp,
                end = 10.dp,
            ),
        shape = RoundedCornerShape(47.dp),
        colors = EventTrackCardColors(eventTrack.backgroundInfo),
    ) {
        Row(
            modifier = Modifier.padding(
                top = 22.dp,
                start = 26.dp,
                end = 0.dp,
                bottom = 22.dp,
            ),
        ) {
            Column {
                Text(
                    text = stringResource(
                        Res.string.event_detail_screen_track_artist_and_track,
                        eventTrack.track.artist.name,
                        eventTrack.track.name,
                    ),
                    style = MaterialTheme.typography.headlineMedium,
                    fontSize = 30.sp,
                    modifier = Modifier.sizeIn(
                        minWidth = MAX_TRACK_NAME_WIDTH.dp,
                        minHeight = 0.dp,
                        maxWidth = MAX_TRACK_NAME_WIDTH.dp,
                        maxHeight = Dp.Unspecified,
                    )
                )

                FlowRow {
                    eventTrack.members.forEach { item ->
                        TrackMember(
                            eventMember = item,
                            backgroundType = eventTrack.backgroundInfo.type,
                            onClicked = { },
                        )
                        Spacer(modifier = Modifier.size(6.dp))
                    }
                }
            }

            Spacer(modifier = Modifier.weight(1.0f).defaultMinSize(10.dp))

            val readyStatus = if (eventTrack.isReady) {
                Res.drawable.ic_ready
            } else {
                Res.drawable.ic_not_ready
            }

            Icon(
                painter = painterResource(readyStatus),
                contentDescription = "ReadyIcon",
                modifier = Modifier.align(Alignment.CenterVertically)
            )

            Spacer(modifier = Modifier.width(32.dp))
        }
    }
}